import { useEffect } from "react";

/**
 * Hook that fires a callback when a click occurs outside the given ref(s).
 *
 * @param {React.RefObject|React.RefObject[]} refs - One or more refs to treat as "inside"
 * @param {function} callback - Called when a click lands outside all refs
 * @param {boolean} [enabled=true] - When false, the listener is not attached
 */
const useClickOutside = (refs, callback, enabled = true) => {
  useEffect(() => {
    if (!enabled) return;

    const refArray = Array.isArray(refs) ? refs : [refs];

    const handleClickOutside = (event) => {
      const isOutside = refArray.every(
        (ref) => !ref.current || !ref.current.contains(event.target)
      );
      if (isOutside) {
        callback(event);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, [refs, callback, enabled]);
};

export default useClickOutside;
